var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100vh","width":"100vw","position":"relative"}},[_c('div',{staticClass:"change-to-word",on:{"click":function($event){return _vm.changeToWord(_vm.pdfUrl, _vm.pdfPaperTitle)}}},[_vm._v(" 转为WORD ")]),_c('embed',{attrs:{"src":_vm.pdfUrl,"type":"application/pdf","height":"100%","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }